// extracted by mini-css-extract-plugin
module.exports = {"portfolio":"page_portfolio__1rdl5","socials":"page_socials__Whble","move":"page_move__1AB_K"};